module.exports = __webpack_public_path__ + "assets/img/title.6190f5a5.svg";